import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/category";

export default class CategoryService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getList(params) {
		return http.get(`${apiEndpoint}/Auth`, { params });
	}

	toggleStatus(id, params) {
		return http.put(`${apiEndpoint}/${id}`, { ...params });
	}
}
